/* Built In Imports */
/* External Imports */
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';

/* Styles */
import InnerSt from '@moms/styleData/InnerSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const FlexItem1 = ({ region, lang, sectionContent }) => {
  const title = sectionContent[0]?.titleText;
  const subtext = sectionContent[0]?.additionalTextLine;
  const desc = sectionContent[1]?.text;
  const buttonText = sectionContent[2]?.buttonText;
  const buttonLink = sectionContent[2]?.linkUrl;
  return (
    <Flex
      flexDir={'column'}
      maxW={'510px'}
      gap={{ base: '2rem', md: '2rem' }}
      ml={{ md: '2rem', xl: '0' }}
      mb="30px"
    >
      {/* main heading  */}
      <Box
        width={'100%'}
        display={{ base: 'block', md: 'flex' }}
        flexDirection={{ md: 'column' }}
        {...InnerSt?.[lang]?.title}
        // fontSize={{ base: '40px', md: '48px' }}
        // lineHeight={{ base: '36px', md: '43.2px' }}
        fontFamily="Trirong"
      >
        <Text
          as={'span'}
          // {...TopBannerSt?.[lang]?.title}
          color={'#EC2224'}
        >
          {title}
          <Text {...InnerSt?.[lang]?.titleSubtext} as={'span'}>
            {' '}
            {subtext}
          </Text>
        </Text>
      </Box>
      <Text {...InnerSt?.[lang]?.desc}>{desc}</Text>
      <Button
        mt={'3rem'}
        height={'56px'}
        as="a"
        href={refineUrlDomain(buttonLink, region, lang)}
        target={isOpenInNewTab(buttonLink) ? '_blank' : ''}
        rel="noopener noreferrer"
        display={{ base: 'none', md: 'flex' }}
        fontWeight={600}
        borderWidth={'1px'}
        width={{ base: '100%', md: '309px' }}
        borderRadius={'55px'}
        fontFamily="Geist"
        color={'#FFFFFF'}
        textTransform="uppercase"
        bgColor={'transparent'}
        _hover={{ background: 'rgba(255, 255, 255, 0.10)' }}
        border="1px solid #fff"
        {...InnerSt[lang].buttonText}
      >
        {buttonText}
      </Button>
    </Flex>
  );
};

const FlexItem2 = ({ region, lang, sectionContent }) => {
  const buttonText = sectionContent[2]?.buttonText;
  const buttonLink = sectionContent[2]?.linkUrl;

  const cards = sectionContent[3]?.cards || [];

  return (
    <Box
      maxW={{ base: '100%', md: '512px' }}
      mx={'auto'}
      alignItems={'center'}
      justifyContent={'center'}
      mt={{ base: '2.2rem', md: '0' }}
      display="flex"
      flexWrap="wrap"
      gap={4}
    >
      {cards.map((card, index) => (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          key={index}
          bg="#FFFFFF"
          width={{ base: '147px', md: '147px', lg: '226px' }}
          height={{ base: '66px', md: '102px' }}
          p="8px"
        >
          {/* <Link href={card.cardLink || '#'} isExternal> */}
          <Image
            src={card.thumbnail?.url}
            display={'block'}
            alt={card.thumbnail?.alt || 'Thumbnail'}
            width={{ base: '100%', md: '100%' }}
            mx={'auto'}
            maxH="80%"
            height="auto"
            objectFit="contain"
          />
          {/* </Link> */}
        </Box>
      ))}
      <Button
        mt={'3rem'}
        height={'46px'}
        as="a"
        href={refineUrlDomain(buttonLink, region, lang)}
        target={isOpenInNewTab(buttonLink) ? '_blank' : ''}
        rel="noopener noreferrer"
        display={{ base: 'flex', md: 'none' }}
        fontWeight={600}
        borderWidth={'1px'}
        width={{ base: '100%', md: '309px' }}
        borderRadius={'55px'}
        fontFamily="Geist"
        color={'#FFFFFF'}
        bgColor={'transparent'}
        _hover={{ background: 'rgba(255, 255, 255, 0.10)' }}
        textTransform="uppercase"
        border="1px solid #fff"
        {...InnerSt[lang].buttonText}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

const Collaboration = ({ sectionContent, region, lang }) => {
  // console.log(sectionContent, 'Inner');

  return (
    <Box px={{ base: '1rem', md: '0' }} py={{ base: '5rem', md: '7.5rem' }}>
      <Flex mx={'auto'} maxW={'1194px'} flexDir={{ base: 'column', lg: 'row' }}>
        <FlexItem1
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
        <FlexItem2
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
      </Flex>
    </Box>
  );
};

export default Collaboration;
